import { render, staticRenderFns } from "./draftactivitymanage.vue?vue&type=template&id=7d23f9b2&scoped=true&"
import script from "./draftactivitymanage.vue?vue&type=script&lang=js&"
export * from "./draftactivitymanage.vue?vue&type=script&lang=js&"
import style0 from "./draftactivitymanage.vue?vue&type=style&index=0&id=7d23f9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23f9b2",
  null
  
)

export default component.exports